var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTengoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 418 706",
    width: 418,
    height: 706,
    role: "img",
    "aria-label": "tengo \\u2014 monograma",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tengo \u2014 monograma") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6D00D6",
    d: "M414 528V677Q362 706 292 706Q201 706 150.5 654.5Q100 603 100 511V307H0V158H100V0H271V158H418V307H271V471Q271 547 340 547Q384 547 414 528Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTengoMark);
export default __webpack_public_path__ + "static/media/tengo-mark.2280cb3f8a6e67001ff27dea042fe04d.svg";
export { ForwardRef as ReactComponent };